import esVuetify from 'vuetify/src/locale/es';

export default {
    ...esVuetify,
    // Traducción propia
    generals: {
        commentsOf: 'comentarios de',
        complement: 'Complement',
        rescheduled: 'Reprogramado',
        of: 'de',
        and: 'y',
        selected: 'seleccionados',
        add: 'Agregar',
        edit: 'Editar',
        save: 'Guardar',
        accept: 'Aceptar',
        cancel: 'Cancelar',
        school: 'Escuela',
        visualize: 'Visualizar',
        help: 'Ayuda',
        userOptions: 'Opciones de Usuario',
        schoolOptions: 'Opciones del Colegio',
        profile: 'Perfil',
        changePassword: 'Cambiar contraseña',
        closeSession: 'Cerrar Sesión',
        selectAll: 'Seleccionar todo',
        search: 'Buscar',
        user: 'Usuario',
        planification: 'Planificación',
        delete: 'Eliminar',
        selectElementsToAdd: 'Selecciona los elementos que se desean agregar',
        unit: 'Unidad',
        subject: 'Asignatura',
        course: 'Curso',
        level: 'Nivel',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Fin',
        teacher: 'Profesor',
        status: 'Estado',
        institution: 'Institución',
        endpointMessages: {
            notProcessed: 'No se pudo procesar su solicitud',
        },
    },
    component: {
        romaHeader: {
            academicYear: 'Año',
        },
        romaOrganizer: {
            title: 'Planificación de Unidad Didáctica',
            annualPlan: 'Plan Anual',
            unit: 'Unidad',
            subject: 'Asignatura',
            course: 'Curso',
            level: 'Nivel',
            startDate: 'Fecha Inicio',
            endDate: 'Fecha Fin',
            teacher: 'Profesor',
            status: 'Estado',
            institution: 'Institución',
            advance: 'Avance',
            active: 'Activo',
            name: 'Nombre',
            year: 'Año',
            removeFilters: 'Borrar Filtros',
        },
        romaFooter: {
            phoneContact: 'Teléfono SAC',
            mobileContact: 'Teléfono móvil',
            emailContact: 'Correo Electrónico',
            developedBy: 'Desarrollado por',
            socialNetworks: '¡Nuestras Redes Sociales!',
            changeLanguage: 'Cambiar idioma',
        },
        romaUnit: {
            duration: 'Duración',
            hours: 'horas',
            objetiveNo: 'Nro. Objetivos',
            activityNo: 'Nro. Actividades',
            comments: 'Comentarios',
            seeComments: 'Ver Comentarios',
            state: 'Estado',
            startDate: 'Fecha Inicio',
            end: 'Fecha Fin',
            profesor: 'Profesor(a)',
        },
        romaUnitList: {
            confirmDelete: '¿Realmente deseas eliminar la unidad seleccionada?',
            uploadExcel: 'Subir excel de planes',
            reportCoverageByCourses: 'Ver reporte de cobertura por cursos',
            reportCoverageByInstitution: 'Ver reporte de cobertura por institución',
            addUnit: 'Agregar Unidad',
            generateReport: 'Generar Reporte',
            unitPlan: 'Plan Unidad',
            annualPlan: 'Plan Anual',
            annualCoverage: 'Cobertura Anual',
            options: 'Opciones',
            editUnit: 'Editar Unidad',
            duplicate: 'Duplicar',
            remove: 'Eliminar',
            editSchedule: 'Editar planificación',
            startReview: 'Iniciar revisión',
            reviewOk: 'Revisión ok',
            reviewWithObservatios: 'Revisión con observaciones',
            closeEdition: 'Cerrar Edición',
            registerAdvance: 'Registrar Avance',
            hasCoveragePart1: 'debes registrar la',
            hasCoveragePart2: 'cobertura',
            hasCoveragePart3: 'para poder avanzar en el plan...',
            hasApprobation: 'El plan debe ser aprobado...',
            hasClose: 'El plan debe estar cerrado...',
            emptyUnitPart1: '¡No hay Unidades agregadas en este momento o con ese criterio de búsqueda por favor usa el botón',
            emptyUnitPart2: 'para agregar una nueva unidad!',
        },
        romaPercentage: {
            percentageAdvancerOas: '% Avance de OA',
            percentageAdvancerCurricular: '% avance curricular:',
            percentageOasPlanificados: '% OA Planificados',
            percentageCurricular: '% curricular:',
        },
        romaUnitModalForm: {
            subjectRequired: 'La Asignatura es requerida',
            subject: 'Asignatura',
            levelRequired: 'El nivel es requerido',
            level: 'Nivel',
            courseRequired: 'El Curso es requerido',
            course: 'Curso',
            courseOriginRequired: 'El Curso Origen es requerido',
            courseOrigin: 'Curso Origen',
            unitRequired: 'La Unidad es requerida',
            unit: 'Unidad (Opcional)',
            descriptionUnitRequired: 'La descripción es requerida',
            descriptionUnitLengthRequired: 'La descripción debe contener entre 3 a 100 caracteres',
            descriptionUnit: 'Descripción Unidad',
            startDateRequired: 'La fecha de inicio es requerida',
            start: 'Inicio',
            endDateRequired: 'La fecha final es requerida',
            end: 'Fin',
            duration: 'Duración (Horas)',
            getPlan: 'Obtener Plan Ministerial',
            duplicated: 'Duplicar de curso ya existente',
            copyFromCourse: 'Seleccionar curso a duplicar',
            copyFromYear: 'Seleccionar año',
            copyOAs: 'Objetivos',
            copyCoverage: 'Cobertura',
            copyActivities: 'Actividades',
            priorityRequired: 'El Plan Ministerial es requerida',
            priority: 'Plan Ministerial',
        },
        romaExcelModalForm: {
            title: 'Subir excel de Planes didácticos de Unidad',
            objetive: 'Objetivos e indicadores',
            learning: 'Aprendizaje previo',
            skills: 'Habilidades',
            attitudes: 'Actitudes',
        },
        romaReportFiltersModal: {
            option: 'Elija las secciones del reporte que desea que aparezcan',
            information: 'Información General',
            planner: 'Planificación de Actividades',
            schedule: 'Cronograma',
            optionEducation: 'Elija la categoria de la educación',
            education: 'Educación',
        },
        romaMessageModal: {
            title: 'Agrega un comentario',
            notComments: 'No hay comentarios!',
            subTitles: 'En el siguiente cuadro realice todas las observaciones que usted cree necesarias que el profesor tome en cuenta para editar su planificación',
            msgRequired: 'El mensaje es requerido',
            lastComments: 'Últimos comentarios',
            linePart1: 'Usuario: ',
            linePart2: 'Estado Plan: ',
        },
        romaPurpose: {
            savePurpose: '¡Descripción de la unidad Guardada!',
            unitDescription: 'Descripción de la unidad',
            notText: 'sin texto (click para editar)',
            clickEdit: 'click para editar',
            placeholderUnitDescription: 'Escriba a continuación la de descripción de la unidad',
            addPreLearningTitle: 'Agregar aprendizaje previo',
            editPreLearningTitle: 'Editar aprendizaje previo',
            addSkill: 'Agregar Habilidad',
            addActitude: 'Agregar Actitud',
            preLearning: 'Aprendizaje previo',
            deletePreLearning: 'Eliminar aprendizaje previo',
            deleteHabilities: 'Eliminar habilidad de asignatura',
            deleteActitude: 'Eliminar actitud',
            confirmPreLearning: '¿Estás seguro de que deseas eliminar el aprendizaje previo seleccionado?',
            confirmHabilities: '¿Estás seguro de que deseas eliminar la habilidad de asignatura seleccionada?',
            confirmActitude: '¿Estás seguro de que deseas eliminar la actitud seleccionada?'
        },
        confirmDiaglog: {
            confirm: 'Realmente deseas eliminar ',
        },
        romaBreadCrumbs: {
            home: 'Planificación',
            unitList: 'Lista Unidades',
            unit: 'Unidad',
            advance: 'Registro de Avance, Unidad'
        },
        unit: {
            purposeTabLabel: 'Descripción',
            objectivesTabLabel: 'Objetivos',
            coverageTabLabel: 'Organización',
            activitiesTabLabel: 'Planificación',
        },
        romaOA: {
            filterObjectivesBy: 'Filtrar objetivos por',
            filterPlaceholder: 'Nombre o código del objetivo',
            actives: 'activos',
            inactives: 'inactivos',
            noObjectives: 'No hay objetivos disponibles',
            activitiesButtonLabel: 'Actividades',
            activateOrInactivateButtonLabel: 'Activar/Inactivar',
            reprogramButtonLabel: 'Reprogramar',
            saveHours: 'Guardar horas',
            addObjective: 'Agregar Objetivo',
            save: 'Guardar',
            filterObjective: 'filtrar objetivos',
            deleteComplement: 'eliminar complemento',
            activitiesOf: 'actividades de',
            commentsOf: 'comentarios de',
            hours: 'Horas',
            hour: 'Hora',
            totalHours: 'Total Horas',
            warningLessHours: 'Total de horas menor a total de horas del plan',
            errorGreaterHours: 'Total de horas excede del total horas del plan',
            endpointMessages: {
                saveHoursSuccess: 'Las horas han sido modificadas!',
                changeStatusSuccess: 'Los estados han sido cambiados!',
                reprogramSuccess: 'Los objetivos han sido reprogramados',
            },
        },
        romaOAModalForm: {
            modalTitle: 'Agregar objetivos e indicadores',
            subjectIsRequired: 'La Asignatura es requerida',
            levelIsRequired: 'El nivel es requerido',
            selectOAsAndIEsToAdd: 'Selecciona los OA e IE que deseas agregar',
            noObjectivesOrExistent: 'No existen objetivos para esta asignatura y categoria o, ya estan agregados al plan unidad',
            endpointMessages: {
                addedObjectiveSuccess: 'Objetivo agregado',
            },
        },
        romaCoverage: {
            objectiveHours: 'Horas del objetivo en la semana',
            pressEnterHint: 'pulse <ENTER> para enviar aceptar',
            assignOA: 'Planificar OA',
            assignAssessment: 'Planificar Evaluación',
            assignIE: 'Asignar IE',
            deleteAssessment: 'Eliminar asignación',
            deletePlanification: 'Eliminar planificación',
            registerAdvance: 'Registro de avance',
            deleteAdvance: 'Eliminar avance',
            unsavedChanges: 'Hay cambios sin guardar en organización, desea guardar?',
            unsavedChangesWarning: 'Hay cambios sin guardar en organización',
            endpointMessages: {
                savedCoverageSuccess: '¡Organización de la unidad Guardada!',
                remember: "Recuerde ejecutar la planificación realizada"
            },
        },
    },
};
